import { render } from "./UpdateTimeTrackingDetails.vue?vue&type=template&id=264590ba"
import script from "./UpdateTimeTrackingDetails.vue?vue&type=script&lang=js"
export * from "./UpdateTimeTrackingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__